import React, { useEffect, useState } from "react";
import Modal from "../../../components/Modal/Modal";
import ProfileService from "../../../services/ProfileService/ProfileService";
import {useTranslation} from "react-i18next";
/**
 * @Description This function returns Alert dialog.
 * @Returns     Component
 * @Author      Kerem Karadeniz
 */
function AlertDialog({ setOpen, open }) {
    const {t} = useTranslation();
    const [data, setData] = useState();
  
  useEffect(() => {
    //actioneer profile list
    if (open?.type === "actioneer-profile") {
      const fetchData = async () => {
        const response = await ProfileService.getActioneersByAlertProfile(open?.id);
        if (response) {
            if(response?.data){
                setData(response.data);
             
            }
          }
      };
      fetchData().then((r) => r);
    }

    if (open?.type === "alert-rule") {
        const fetchData = async () => {
          const response = await ProfileService.getAlertByAlertRule(open?.id);
          if (response) {
              if(response?.data){
                  setData(response.data);
                
              }
            }
        };
        fetchData().then((r) => r);
      }

      if (open?.type === "automs") {
        const fetchData = async () => {
          const response = await ProfileService.getAutomsByAlertProfile(open?.id);
          if (response) {
              if(response?.data){
                  setData(response.data);
                
                  
              } 
            }
        };
        fetchData().then((r) => r);
      }
  }, []);
  return <Modal setOpen={setOpen} title={t(`CONTENT.ALERT.${open?.type.toUpperCase()}`)} >
        <div className="form-element">
            {open?.type === "actioneer-profile" &&
                data?.map((item, index) => 
                        <div style={{fontSize:13,marginBottom:3}} key={item?.id} >{index + 1}. {item?.name}</div>
                    )
            }
            {open?.type === "alert-rule" &&
                data?.map((item, index) => 
                        <div style={{fontSize:13,marginBottom:3}} key={item?.id} >{index + 1}. {item?.message}</div>
                    )
            }
             {open?.type === "automs" &&
                data?.map((item, index) => 
                        <div style={{fontSize:13,marginBottom:3}} key={item?.id} >{index + 1}. {item?.name}</div>
                    )
            }
        </div>

  </Modal>;
}
export default AlertDialog;
